
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'


export default {
components: {
XHeader,
XInput,
Group,
XButton,
Cell,
Selector,
},
data() {
return {
orderDetail: {},
iden: '',
ftype: '1',
flag: false,
list: [{key: 1, value: '信息'}, {key: 2, value: '警告'}, {key: 3, value: '错误'}, {key: 4, value: '紧急'}]
}
},
methods: {
faultRecord() {
this.$router.push({name: 'recordlist'})
},
Revisionlevel() {
var opid = localStorage.getItem('userid')
var that = this
var header = {
headers: {
token: localStorage.getItem('token'),
opid: opid
}
}
var obj = {
'userid': opid,
'role': this.iden,
'level': this.ftype
}
this.$http.put('api/v1/devices/' + this.orderDetail.seq + '/bondlevel', obj, header)
.then(res => {
console.log(res)
that.$router.push({name: 'Devicelist'})
})
.catch(err => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
},
Unbind() {
var opid = localStorage.getItem('userid')
var header = {
headers: {
token: localStorage.getItem('token'),
opid: opid
}
}
var obj = {
'userid': opid,
'role': this.iden
}
var that = this
this.$http.put('api/v1/devices/' + this.orderDetail.seq + '/unbond', obj, header)
.then(res => {
that.$router.push({name: 'Devicelist'})
})
.catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
},
binding() {
var opid = localStorage.getItem('userid')
var header = {
headers: {
token: localStorage.getItem('token'),
opid: opid
}
}
if (!opid) {
this.$vux.alert.show({
title: '',
content: '请先登录，然后再进行绑定，如果您还没有注册，请先注册为个人用户。'
})
this.$router.push({name: 'register', query: {role: 'users'}})
return;
}
if (!this.iden) {
this.$vux.alert.show({
title: '',
content: '您还没有个人用户身份，请先添加个人用户身份，然后再进行绑定。',
})
this.$router.push({name: 'vip'})
return
}
var obj = {
'userid': opid,
'role': this.iden,
'level': this.ftype
}
var that = this
this.$http.put('api/v1/devices/' + this.orderDetail.seq + '/bond', obj, header)
.then(res => {
that.$router.push({name: 'Devicelist'})
})
.catch(error => {
if (error.response.data) {
that.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
}
})
}
},
beforeRouteEnter(to, from, next) {
if (from.name == 'Devicelist') {
next(vm => {
vm.orderDetail = vm.$route.params.order
vm.ftype = vm.orderDetail.level
vm.flag = true
var order = JSON.stringify(vm.orderDetail)
localStorage.setItem('order', order)
localStorage.setItem('flag', true)

let opid = localStorage.getItem('userid');
var header = {
headers: {
token: localStorage.getItem('token'),
opid: opid
}
}
vm.$http.get('/api/v1/accounts/' + opid, header)
.then(function (res) {
for (let i = 0; i < res.data.length; i++) {
if (res.data[i].type == 'INDV') {
vm.iden = 'INDV'
}
if (res.data[i].type == 'ENTP') {
vm.iden = 'ENTP'
}
}
})
})
} else if (from.name == 'sbxx') {
next(vm => {
vm.orderDetail = vm.$route.params.order
var order = JSON.stringify(vm.orderDetail)
localStorage.setItem('order', order)
localStorage.setItem('flag', false)
var role = vm.$route.params.role
vm.iden = role
})
} else {
next(vm => {
var order = localStorage.getItem('order')
vm.orderDetail = JSON.parse(order)
vm.flag = localStorage.getItem('flag')
if (vm.orderDetail.level) {
vm.ftype = vm.orderDetail.level
}
let opid = localStorage.getItem('userid');
var header = {
headers: {
token: localStorage.getItem('token'),
opid: opid
}
}
vm.$http.get('/api/v1/accounts/' + opid, header)
.then(function (res) {
for (let i = 0; i < res.data.length; i++) {
if (res.data[i].type == 'INDV') {
vm.iden = 'INDV'
}
if (res.data[i].type == 'ENTP') {
vm.iden = 'ENTP'
}
}
})
})
}
},
beforeRouteLeave(to, from, next) {
if (to.name == 'recordlist') {
next()
} else {
localStorage.removeItem('order')
localStorage.removeItem('flag')
}
next()
}
}



// WEBPACK FOOTER //
// ./src/components/smallbox.vue